import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ReportGroup, PageContent, Content } from '../objects/WorkObject';
import { TokenManager } from '../Globals';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from '../objects/Globals';
import { WorkspaceService } from '../services/workspace.service';
import { ThemeSettingService } from '../services/theme-setting.service';
import { LoginService } from '../services/login.service';
import { Subscription } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConversationService } from '../services/conversation.service';

@Component({
  selector: 'app-layout-workspace',
  templateUrl: './layout-workspace.component.html',
  styleUrls: ['./layout-workspace.component.css']
})

export class LayoutWorkspaceComponent implements OnInit, OnDestroy {

  @HostListener('document:click', ['$event'])
  clickout(event) {
    var element = event.target as HTMLElement;
    if(element.classList.contains('auto-reply')) {
      this.searchGlobal(element.getAttribute('data-value'));
    }
  }

  pageContent:PageContent;
  private reportGroup:ReportGroup;
  private reportGroupList:ReportGroup[] = new Array();
  private loaderConfig:any;
  private isBusy:boolean = false;
  private gridColumns: string;
  private gridRows:string;
  private msGridColumns:string = "";
  private msGridRows:string = "";
  private gridRowsDefaultArray = [];
  private reportGridHeightArray = [];
  private sub: Subscription;
  private isMobile: boolean = false;

  constructor(private workspaceService:WorkspaceService, private loginService: LoginService, private deviceService: DeviceDetectorService,
    private tokenManager:TokenManager, private router:Router, private globals:Globals, 
    private route:ActivatedRoute, private themeSettingService: ThemeSettingService,
    private conversationService: ConversationService) {
    this.isMobile = deviceService.isMobile();
   }
  
   ngOnDestroy(){
    //  this.sub.unsubscribe();
   }

   searchGlobal(value:string){
    this.isBusy = true;
    if (value){
      this.conversationService.converse(value).subscribe(result=> {
        var resultObject = JSON.parse(result);
        this.isBusy = false;
          if(resultObject.ReturnType == "0"){
            if(resultObject.Arguments){
              var path = [];
              resultObject.Arguments.forEach(element => {
                path.push(element);
              });;
              this.router.navigate(path);
            }
          }
      }, error => {
        this.isBusy = false;
      });
    }
    else {
      this.isBusy = false;
    }
  }

  ngOnInit() {
    this.loaderConfig = this.themeSettingService.getTheme();
    this.tokenManager.store("BRNCurrentRoute", this.router.url);
    if(this.globals == null){this.router.navigate(['/', '/']) };
    if(this.globals.Session == null){this.router.navigate(['/', '/']) };

    if(this.globals.Session){
      var page:string = this.route.snapshot.paramMap.get('page');
      this.isBusy = true;
      this.workspaceService.getEPICPage(page, this.isMobile).subscribe(result=>{
        this.isBusy = false;
        this.pageContent = JSON.parse(result);
        // console.log(this.pageContent);
        this.gridColumns = "repeat(" + this.pageContent.PageWidth + ", 1fr)";

        for (var i = 0;i < this.pageContent.PageWidth;i++){
          this.msGridColumns += "1fr "
        }
        
        if (this.pageContent.PageIsFixedSize){
          document.querySelectorAll('.body-wrapper').item(0).classList.remove("scroll");
          this.gridRowsDefaultArray = Array(this.pageContent.PageHeight).fill("1fr");
          this.gridRows = "repeat(" + this.pageContent.PageHeight + ", 1fr)";
          for (var i = 0;i < this.pageContent.PageHeight;i++){
            this.msGridRows += "1fr "
          }
        }
        else {
          document.querySelectorAll('.body-wrapper').item(0).classList.add("scroll");
          this.gridRows = "repeat(" + this.pageContent.PageHeight + ", 50px)";
          for (var i = 0;i < this.pageContent.PageHeight;i++){
            this.msGridRows += "50px "
          }
        }

        var objGroup = [];
        var index = 0;

        this.sort(this.pageContent.Content);
        // console.log(this.pageContent.Content);

        this.pageContent.Content.forEach(obj => {
          if(obj.PositionX == 0){
            obj.PositionX = 1;
          }
          if (obj.PositionY == 0){
            obj.PositionY = 1;
          }
          objGroup.push({
            index: index,
            groupId : obj.EPICContentId, 
            positionX : obj.PositionX, 
            positionY: obj.PositionY 
          });

          const posX = obj.PositionX;
          const posY = obj.PositionY;

          // this.promiseGetEpicGroup(obj.EPICContentId).then(result => {
          //   var reportGroup:ReportGroup = JSON.parse(result);

          //   reportGroup.StartRow = posY == 0 ? 1 : posY;
          //   reportGroup.StartColumn = posX == 0 ? 1 : posX;
            
          //   this.reportGroupList.splice(index, 0, reportGroup);
          // })

          // this.getEPICGroup(obj.EPICContentId, obj.PositionX, obj.PositionY);

          index++;
        });
        //this.getAllEPICGroup(objGroup);
      });
    }
  }

  setReportGroup(reportGroup: ReportGroup){
    this.reportGroupList.push(reportGroup);
  }

  getGridConfig(groupId: string, type: string ){
    if (this.reportGroupList.length > 0){
      var i = this.reportGroupList.find(x => x.GroupId == groupId);
      if (i){
        switch(type){
          case "startColumn":
            return i.StartColumn;
          case "startRow":
            return i.StartRow;
          case "height":
            return i.Height;
          case "width":
            return i.Width;  
        }
      }
    }
  }

  promiseGetEpicGroup(groupId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.workspaceService.getEPICGroup(this.pageContent.EPICPageId, groupId).subscribe(result=>{
        resolve(result);
      });
    });
  }

  sort(objGroup:Content[]){
    return objGroup.sort((a:Content,b:Content) => { 
      if(a.PositionX > b.PositionX){
        return 1;
      }
      
      if(a.PositionX < b.PositionX){
        return -1;
      }

      if(a.PositionY > b.PositionY){
        return 1;
      }
      
      if(a.PositionY < b.PositionY){
        return -1;
      }
      
      return 0;
      
    });
  }


  setGridRows(rowSizeArray: string[], startRow: number){
    var ultimateRows = "";
    var msUltimateRows = "";

    var indexArray = [];
      // var startRow = reportGroup.StartRow;
      rowSizeArray.forEach(element => {
        indexArray.push({index: startRow - 1, size: element})
        startRow++;
      });
  
      indexArray.forEach(obj => {
        this.gridRowsDefaultArray[obj.index] = obj.size;
      });
  
      var array = this.gridRowsDefaultArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index);  //remove duplicates

    if (this.pageContent.PageIsFixedSize){
      array.forEach(element => {
          ultimateRows = ultimateRows + "repeat(" + this.gridRowsDefaultArray.filter(x => x == element).length + ", " + element + ") ";
          for (var i =0; i < this.gridRowsDefaultArray.filter(x => x == element).length; i++){
            msUltimateRows = msUltimateRows + element + " ";
          }
      })

      this.gridRows = ultimateRows;
      this.msGridRows = msUltimateRows;
    }
    else{
      this.reportGridHeightArray.push(array);
      if (this.reportGridHeightArray.length == this.pageContent.Content.length){
        var stuff = this.reportGridHeightArray[this.reportGridHeightArray.length - 1];

        stuff.forEach(element => {
          var value = element;
          if (element == "minmax(0px, 1fr)"){ // this needs to have the same value as grid rows in report group
            value = "50px";
          }
          ultimateRows = ultimateRows + "repeat(" + this.gridRowsDefaultArray.filter(x => x == element).length + ", " + value + ") ";
          for (var i =0; i < this.gridRowsDefaultArray.filter(x => x == element).length; i++){
            msUltimateRows = msUltimateRows + element + " ";
          }
          this.gridRows = ultimateRows;
          this.msGridRows = msUltimateRows;
        });
        
      }
    }
  }

  getEPICGroup(groupId, positionX, positionY){
    this.workspaceService.getEPICGroup(this.pageContent.EPICPageId ,groupId).subscribe(result=>{
      this.reportGroup = JSON.parse(result);
      if(positionX == 0){
        positionX = 1;
      }
      if (positionY == 0){
        positionY = 1;
      }

      this.reportGroup.StartRow = positionY;
      this.reportGroup.StartColumn = positionX;
      
      this.reportGroupList.push(this.reportGroup);
    });
  }

  getAllEPICGroup(obj:any) {
    var groupIds = [];
    obj.forEach(element => {
      groupIds.push(element.groupId);
    });
    var reportGroup:ReportGroup[] = [];
    this.workspaceService.getEPICGroupAll(this.pageContent.EPICPageId, groupIds).subscribe(results => {
      var i = 0;
      for(let result of results) {
        var report:ReportGroup;
        report = JSON.parse(result);
        report.StartRow = obj.find(x=> x.index == i).positionY;
        report.StartColumn = obj.find(x=> x.index == i).positionX;
        reportGroup.push(report);
        i++;
      }
      this.reportGroupList = reportGroup;
      
    });
  }
}